var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "offer-form uk-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('validation-alert-box', {
    attrs: {
      "errors": _vm.fields.errors.base
    }
  }), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.basicFields')))]), _vm._v(" "), _c('product-combobox', {
    attrs: {
      "label": _vm.$t('fields.product'),
      "errors": _vm.fields.errors.product,
      "placeholder": _vm.$t('placeholders.withoutProduct'),
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.product),
      callback: function($$v) {
        _vm.fields.values.product = $$v
      },
      expression: "fields.values.product"
    }
  }), _vm._v(" "), _c('contract-combobox', {
    attrs: {
      "label": _vm.$t('fields.contract'),
      "errors": _vm.fields.errors.contract,
      "placeholder": _vm.$t('placeholders.withoutContract'),
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.contract),
      callback: function($$v) {
        _vm.fields.values.contract = $$v
      },
      expression: "fields.values.contract"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.prices')) + "\n    ")]), _vm._v(" "), _c('price-manager', {
    attrs: {
      "value": _vm.fields.values.prices,
      "errors": _vm.fields.errors.prices,
      "disabled": !_vm.isEditable
    },
    on: {
      "change": _vm.fields.change.prices
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.publications')) + "\n    ")]), _vm._v(" "), _c('publication-manager', {
    attrs: {
      "value": _vm.fields.values.publications,
      "errors": _vm.fields.errors.publications,
      "disabled": !_vm.isEditable
    },
    on: {
      "change": _vm.fields.change.publications
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.details')))]), _vm._v(" "), _c('text-input', {
    staticClass: "uk-width-1-4",
    attrs: {
      "type": "number",
      "label": _vm.$t('fields.maxOrderableAmount'),
      "errors": _vm.fields.errors.maxOrderableAmount,
      "disabled": !_vm.isEditable,
      "min": 1
    },
    model: {
      value: (_vm.fields.values.maxOrderableAmount),
      callback: function($$v) {
        _vm.fields.values.maxOrderableAmount = _vm._n($$v)
      },
      expression: "fields.values.maxOrderableAmount"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "label": _vm.$t('fields.usps'),
      "errors": _vm.fields.errors.usps,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.usps),
      callback: function($$v) {
        _vm.fields.values.usps = $$v
      },
      expression: "fields.values.usps"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "label": _vm.$t('fields.summaryTexts'),
      "errors": _vm.fields.errors.summaryTexts,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.summaryTexts),
      callback: function($$v) {
        _vm.fields.values.summaryTexts = $$v
      },
      expression: "fields.values.summaryTexts"
    }
  }), _vm._v(" "), _c('text-area-input', {
    attrs: {
      "label": _vm.$t('fields.priceExtraInformation'),
      "errors": _vm.fields.errors.priceExtraInformation,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.priceExtraInformation),
      callback: function($$v) {
        _vm.fields.values.priceExtraInformation = $$v
      },
      expression: "fields.values.priceExtraInformation"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.media')) + "\n    ")]), _vm._v(" "), _c('attachment-manager', {
    attrs: {
      "attachment-type": "MEDIA_OBJECT",
      "errors": _vm.fields.errors.media,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.media),
      callback: function($$v) {
        _vm.fields.values.media = $$v
      },
      expression: "fields.values.media"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-medium-top"
  }, [_c('submit-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isSubmittable
    }
  }), _vm._v(" "), _c('cancel-button')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e14c6d5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/OfferForm.vue
// module id = 1944
// module chunks = 0